import gql from 'graphql-tag';

export default gql`
  mutation storeCreate($input: CreateStoreInput!) {
    storeCreate(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
